import React from 'react';
import HeaderAdv1 from './HeaderAdv1';
import CTAButton from './CTAButton';
import { CheckCircleIcon } from 'lucide-react';
const AdvertorialAdv1 = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-416">
      <HeaderAdv1 data-id="element-417" />
      <main className="px-4 sm:px-8 py-8" data-id="element-418">
        <div className="prose max-w-none" data-id="element-419">
          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-420">
            My wife Margaret thinks I'm crazy for sharing this story. But after
            what happened last month – another publisher from California called
            me amazed because our sheets were the only ones still working after
            a year in their "longevity test" – I realized more people need to
            know the truth about grounding sheets.
          </p>
          <p className="mb-5 text-base" data-id="element-421">
            And why 99% of them are designed to fail.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-422">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-423"></span>
            The $600 Problem That Started Everything
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-424">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-425">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nKtDziceJGuRNwP75tsSGP/2_The_600_Problem_That_Started_Everything.png" alt="Specialized manufacturing equipment for grounding sheets" className="w-full rounded-lg shadow-md" data-id="element-426" />
            </div>
            <div className="sm:w-1/2" data-id="element-427">
              <p className="mb-5 text-base" data-id="element-428">
                In 2021, I was 68 years old, retired from Corning after 32 years
                designing fiber optic cables, and dealing with hip pain that
                made my sleep impossible.
              </p>
              <p className="mb-5 text-base" data-id="element-429">
                Margaret had chronic lower back pain from her nursing career.
              </p>
              <p className="mb-5 text-base" data-id="element-430">
                And we tried everything to somehow get relief – new mattresses,
                supplements, medications, various physical therapies, but
                nothing really made it any better.
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-431">
            Then Margaret's sister sent us a "grounding" sheet for Christmas.
          </p>
          <p className="mb-5 text-base italic border-l-4 border-gray-400 pl-5 py-3 bg-gray-50 rounded-r text-gray-700" data-id="element-432">
            "It connects you to the earth's electrical field," she said. "It
            works great with my arthritis, just try it."
          </p>
          <p className="mb-5 text-base" data-id="element-433">
            Look, I'm an engineer, and I only trust measurable results. So as
            soon as I unpacked them, I tested our body voltage:
          </p>
          <div className="my-8" data-id="element-434">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pwGSf7YcW4HW7Azrbymd6z/3_0.20_ohms.png" alt="Multimeter showing 0.20 volts reading on grounding sheet" className="w-full rounded-lg shadow-md" data-id="element-435" />
          </div>
          <div className="border-l-4 border-yellow-400 pl-5 py-4 bg-yellow-50 rounded-r mb-5" data-id="element-436">
            <p className="mb-2 text-base" data-id="element-437">
              <strong data-id="element-438">Without the sheet:</strong> 3.2 volts
            </p>
            <p className="text-base" data-id="element-439">
              <strong data-id="element-440">With the sheet:</strong> 0.20 volts
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-441">The physics were real.</p>
          <p className="mb-5 text-base" data-id="element-442">
            And even more importantly - on the first night, I actually slept
            eight hours straight for the first time in years.
          </p>
          <p className="mb-5 text-base" data-id="element-443">And Margaret's back pain was gone.</p>
          <p className="mb-6 text-base" data-id="element-444">We loved it. For about 2.5 months…</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-445">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-446"></span>
            And Then They Died
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-447">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-448">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rLRWYSXKHjYrc1MiEaHP7S/4_And_Then_They_Died.jpg" alt="Grounding sheet with cord showing wear" className="w-full rounded-lg shadow-md" data-id="element-449" />
            </div>
            <div className="sm:w-1/2" data-id="element-450">
              <p className="mb-5 text-base" data-id="element-451">
                It was the second laundry day of month three.
              </p>
              <p className="mb-5 text-base" data-id="element-452">
                I remember how Margaret woke up at 2 AM grabbing her back.
              </p>
              <p className="mb-5 text-base" data-id="element-453">And I felt my hip was throbbing.</p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-454">
            And after I tested the sheets with my multimeter - It was dead.
            Completely non-conductive.
          </p>
          <p className="mb-5 text-base" data-id="element-455">
            "Must be a defective one," I thought.
          </p>
          <p className="mb-5 text-base" data-id="element-456">
            So we bought another one. From a different brand.
          </p>
          <p className="mb-5 text-base" data-id="element-457">More expensive – $179 this time.</p>
          <p className="mb-5 text-base" data-id="element-458">
            But then same pattern was going on for a year:
          </p>
          <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-459">
            <p className="mb-2 text-base" data-id="element-460">Brand #2: Died after 4 months</p>
            <p className="mb-2 text-base" data-id="element-461">Brand #3: Dead at 3.5 months</p>
            <p className="text-base" data-id="element-462">Brand #4: Dead at 3 months</p>
          </div>
          <p className="mb-6 text-base" data-id="element-463">
            In one year, we spent $647 on grounding sheets.
          </p>
          <p className="mb-6 text-base" data-id="element-464">
            Each one worked beautifully for our pain... until it didn't.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-465">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-466"></span>
            The Problem Became Obvious
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-467">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-468">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3WYGCK3KRSHPnSWD5R78CZ/5_The_Problem_Became_Obvious.png" alt="UV flashlight revealing oxidation on grounding sheet" className="w-full rounded-lg shadow-md" data-id="element-469" />
            </div>
            <div className="sm:w-1/2" data-id="element-470">
              <p className="mb-5 text-base" data-id="element-471">
                After the fourth dead sheet, I did what I should have done
                earlier – I grabbed my UV flashlight from my electronics
                toolkit.
              </p>
              <p className="mb-5 text-base" data-id="element-472">
                The problem was obvious: it was Silver oxidation.
              </p>
              <p className="mb-5 text-base" data-id="element-473">
                When silver reacts with oxygen, sweat, and laundry detergent, it
                forms silver oxide – which doesn't conduct electricity.
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-474">
            These sheets were using silver content with ZERO protection.
          </p>
          <p className="mb-5 text-base" data-id="element-475">
            Once that silver oxidized, the sheet became expensive cotton.
          </p>
          <p className="mb-5 text-base font-bold" data-id="element-476">
            This is basic materials science.
          </p>
          <p className="mb-5 text-base" data-id="element-477">
            Any engineer knows unprotected silver oxidizes.
          </p>
          <p className="mb-6 text-base" data-id="element-478">
            These companies HAD to know their sheets would die.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-479">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-480"></span>
            "Why Would We Want Sheets That Last?"
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-481">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-482">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7ocbBmznY7pDnUuwSC9q2t/6_Why_Would_We_Want_Sheets_That_Last.png" alt="Cross-section diagram showing triple-shield threading technology with outer shield, middle barrier, and conductive core" className="w-full rounded-lg shadow-md" data-id="element-483" />
            </div>
            <div className="sm:w-1/2" data-id="element-484">
              <p className="mb-5 text-base" data-id="element-485">
                I thought I could help. I spent three weeks designing a solution
                – a way to protect the silver while maintaining conductivity.
              </p>
              <p className="mb-5 text-base" data-id="element-486">
                I reached out to three major grounding sheet manufacturers with
                my design.
              </p>
              <p className="mb-5 text-base" data-id="element-487">
                The first two didn't respond. The third did – and I'll never
                forget the call:
              </p>
            </div>
          </div>
          <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r mb-5" data-id="element-488">
            <p className="mb-4 italic text-gray-700 text-base" data-id="element-489">
              "Tom, I appreciate your innovation, but our average customer
              reorders every 4.2 months. If sheets lasted five years, we'd lose
              90% of our revenue. Our investors wouldn't approve."
            </p>
            <p className="mb-4 text-base" data-id="element-490">
              "So you're intentionally selling products that fail?"
            </p>
            <p className="italic text-gray-700 text-base" data-id="element-491">
              "We're selling products that work exactly as long as they need
              to."
            </p>
          </div>
          <p className="mb-6 text-base" data-id="element-492">I hung up.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-493">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-494"></span>
            The Submarine Cable Solution
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-495">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-496">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Pt9npvvzUXJSsfd9YQy1Q/7_The_Submarine_Cable_Solution.jpg" alt="Submarine cables on the ocean floor" className="w-full rounded-lg shadow-md" data-id="element-497" />
            </div>
            <div className="sm:w-1/2" data-id="element-498">
              <p className="mb-5 text-base" data-id="element-499">
                That night, I couldn't sleep (ironically). I kept thinking about
                my career at Corning, specifically our submarine cable projects.
              </p>
              <p className="mb-5 text-base" data-id="element-500">
                Those cables sit on the ocean floor for 25+ years. Salt water.
                Pressure. Currents.
              </p>
              <p className="mb-5 text-base" data-id="element-501">
                Yet they maintain perfect conductivity for decades.
              </p>
              <p className="mb-5 text-base" data-id="element-502">How?</p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-503">
            Hermetic shielding. Multiple protective layers where the outer layer
            sacrifices itself to protect the inner core.
          </p>
          <p className="mb-5 text-base" data-id="element-504">At 3 AM, I woke Margaret up.</p>
          <p className="mb-5 text-base" data-id="element-505">"I know how to fix the sheets."</p>
          <p className="mb-5 text-base" data-id="element-506">"Tom, go back to sleep."</p>
          <p className="mb-5 text-base" data-id="element-507">
            "No, listen – submarine cables. We use the same principle.
            Triple-layer threading. The outer layer oxidizes but the inner
            layers stay perfect."
          </p>
          <p className="mb-6 text-base" data-id="element-508">
            She looked at me like I'd lost my mind and went back to sleep.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-509">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-510"></span>
            The $388,716 Investment
          </h2>
          <p className="mb-5 text-base" data-id="element-511">
            I called three former colleagues from Corning.
          </p>
          <p className="mb-5 text-base" data-id="element-512">
            Engineers I've worked with for decades.
          </p>
          <p className="mb-5 text-base" data-id="element-513">
            Actual professionals, those I trust with my life
          </p>
          <p className="mb-5 text-base" data-id="element-514">
            "Here's what I'm thinking," I explained. "We create Triple-Shield
            Threading:
          </p>
          <div className="sm:flex items-center mb-6" data-id="element-515">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-516">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/owwNKSeWjDrgqqyCmjPxvs/9_The_388%2C716_Investment.png" alt="Tom Davidson on video call discussing the investment" className="w-full rounded-lg shadow-md" data-id="element-517" />
            </div>
            <div className="sm:w-1/2" data-id="element-518">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-r" data-id="element-519">
                <p className="mb-3 text-base" data-id="element-520">
                  <strong data-id="element-521">Outer sacrificial shield</strong> – takes the
                  oxidation
                </p>
                <p className="mb-3 text-base" data-id="element-522">
                  <strong data-id="element-523">Middle barrier layer</strong> – backup protection
                </p>
                <p className="mb-3 text-base" data-id="element-524">
                  <strong data-id="element-525">Protected conductive core</strong> – never exposed to
                  oxidation
                </p>
                <p className="mt-4 text-base" data-id="element-526">
                  Plus, we use 47 twists per inch to create a helix pattern.
                  Even if 70% of the outer silver oxidizes, full conductivity
                  remains.
                </p>
              </div>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-527">They were in.</p>
          <p className="mb-5 text-base" data-id="element-528">
            But there was a problem: We needed specialized looms that could
            handle triple-layer weaving without destroying the threads.
          </p>
          <p className="mb-5 text-base" data-id="element-529">Cost: $375,000.</p>
          <div className="my-8" data-id="element-530"></div>
          <p className="mb-5 text-base" data-id="element-531">
            "Tom, that's our retirement fund," Margaret said when I told her the
            plan.
          </p>
          <p className="mb-5 text-base" data-id="element-532">"I know."</p>
          <p className="mb-5 text-base" data-id="element-533">"All of it."</p>
          <p className="mb-5 text-base" data-id="element-534">"I know."</p>
          <p className="mb-5 text-base" data-id="element-535">"For bed sheets?"</p>
          <p className="mb-6 text-base" data-id="element-536">
            She didn't talk to me for three days. Then she said: "If you're
            doing this, they better be the best damn sheets ever made."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-537">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-538"></span>
            The First Sheet That Wouldn't Die
          </h2>
          <div className="my-8" data-id="element-539">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qmNtrL8XYAiA3XeDH8PovT/11_The_First_Sheet_That_Wouldnt_Die.png" alt="Grounding sheet testing with multimeter showing consistent readings" className="w-full rounded-lg shadow-md" data-id="element-540" />
          </div>
          <p className="mb-5 text-base" data-id="element-541">
            It took four months to get the equipment and perfect the weaving
            process.
          </p>
          <p className="mb-5 text-base" data-id="element-542">
            Our first prototype used 10% silver with our triple-shield
            technology.
          </p>
          <p className="mb-5 text-base" data-id="element-543">I tested it obsessively:</p>
          <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-544">
            <p className="mb-2 text-base text-green-700" data-id="element-545">Day 1: 19 ohms</p>
            <p className="mb-2 text-base text-green-700" data-id="element-546">
              Month 1 (after 4 washes): 20 ohms
            </p>
            <p className="mb-2 text-base text-green-700" data-id="element-547">
              Month 3 (after 12 washes): 21 ohms
            </p>
            <p className="text-base text-green-700" data-id="element-548">
              Month 6 (after 24 washes): 22 ohms
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-549">
            Margaret and I slept on it every night.
          </p>
          <p className="mb-5 text-base" data-id="element-550">We washed it weekly.</p>
          <p className="mb-5 text-base" data-id="element-551">
            And after one year it still conducted at 26 ohms.
          </p>
          <p className="mb-6 text-base" data-id="element-552">I was so happy.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-553">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-554"></span>
            And Yes It's Patented
          </h2>
          <div className="my-8" data-id="element-555">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aopFdiTodBDXd2FGSDgVjN/12_Boy_We_Patened_It.png" alt="United States Patent certificate for Tom Davidson's triple-shield threading technology" className="w-full rounded-lg shadow-md" data-id="element-556" />
          </div>
          <p className="mb-5 text-base" data-id="element-557">
            We filed for a patent (US #10,847,293) to protect the triple-shield
            helical weaving process.
          </p>
          <p className="mb-5 text-base" data-id="element-558">Then I made sheets for our family.</p>
          <p className="mb-5 text-base" data-id="element-559">
            My brother with his construction-damaged back.
          </p>
          <p className="mb-5 text-base" data-id="element-560">
            Margaret's sister with rheumatoid arthritis.
          </p>
          <p className="mb-5 text-base" data-id="element-561">
            Our son in Denver who hadn't slept well since his car accident.
          </p>
          <p className="mb-5 text-base" data-id="element-562">
            Every single one called within a month:
          </p>
          <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r mb-5" data-id="element-563">
            <p className="mb-3 italic text-gray-700 text-base" data-id="element-564">
              "Tom, my back pain is gone."
            </p>
            <p className="mb-3 italic text-gray-700 text-base" data-id="element-565">
              "How do I get more of these?"
            </p>
            <p className="mb-0 italic text-gray-700 text-base" data-id="element-566">
              "Do you have a bigger size?"
            </p>
          </div>
          <p className="mb-6 text-base" data-id="element-567">
            My brother tested his after six months: "Tom, it's still at 28 ohms.
            My old sheets would be dead by now."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-568">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-569"></span>
            From Louisville Garages to Local Customers
          </h2>
          <div className="my-8" data-id="element-570">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pmoTChQQEvqQKhJcdPySaT/13_From_Louisville_Garages_to_Local_Customers.jpg" alt="BareEarth shipping boxes on front porch" className="w-full rounded-lg shadow-md" data-id="element-571" />
          </div>
          <p className="mb-5 text-base" data-id="element-572">
            We started small. Really small. Making sheets in a converted garage
            in Louisville with our specialized loom.
          </p>
          <p className="mb-5 text-base" data-id="element-573">
            Word spread through our neighborhood, then our city. People would
            drive from the area after hearing about "those sheets that don't
            die."
          </p>
          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-574">
            The Reality of Our Production
          </h3>
          <div className="my-8" data-id="element-575">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uu9UMfwuW77wygnEwf8b6k/14_The_Reality_of_Our_Production.png" alt="Tom Davidson and colleagues working in the production facility" className="w-full rounded-lg shadow-md" data-id="element-576" />
          </div>
          <p className="mb-5 text-base" data-id="element-577">We make about 500 sheets per month.</p>
          <p className="mb-5 text-base" data-id="element-578">
            The triple-layer weaving takes three times longer than regular
            sheets.
          </p>
          <p className="mb-5 text-base" data-id="element-579">
            The specialized equipment can't be rushed.
          </p>
          <p className="mb-6 text-base" data-id="element-580">
            We're not a big company. And we won't be.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-581">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-582"></span>
            Why I'm Sharing This Now
          </h2>
          <div className="my-8" data-id="element-583">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfnfZQd9BjKTeMstJFsXRS/15_Why_Im_Sharing_This_Now.png" alt="Email from customer Susan Mayers about the grounding sheets still working after six months" className="w-full rounded-lg shadow-md" data-id="element-584" />
          </div>
          <p className="mb-5 text-base" data-id="element-585">
            Last month, I got an email from a woman in Michigan. She'd bought
            seven grounding sheets in two years. All dead. She was about to give
            up on grounding entirely.
          </p>
          <p className="mb-5 text-base" data-id="element-586">
            "My husband thinks I'm wasting money on snake oil," she wrote.
          </p>
          <p className="mb-5 text-base" data-id="element-587">
            I sent her one of our sheets with a multimeter and told her to test
            it every month.
          </p>
          <p className="mb-5 text-base" data-id="element-588">Six months later:</p>
          <p className="mb-6 text-base" data-id="element-589">
            That's when I realized – people need to know this technology exists.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-590">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-591"></span>
            The Offer I'm Making
          </h2>
          <p className="mb-5 text-base" data-id="element-592">
            Margaret says I'm too soft for business, but here's what I'm doing:
          </p>
          <p className="mb-5 text-base" data-id="element-593">
            For anyone reading this article, I'll make our sheets available at
            our production cost plus just enough to keep the lights on: $109.90
            (regularly $219.98).
          </p>
          <p className="mb-5 text-base" data-id="element-594">
            I'm 73 years old. I don't need to get rich.
          </p>
          <p className="mb-5 text-base" data-id="element-595">
            I need to sleep well knowing we're helping people.
          </p>
          <p className="mb-5 text-base" data-id="element-596">
            We have about 280 sheets in our current inventory, I'd be happy to
            send them all out.
          </p>
          <p className="mb-5 text-base" data-id="element-597">
            After some time the word spreads. This is what marketing used to be
            like when I was young.
          </p>
          <p className="mb-6 text-base" data-id="element-598">
            Every sheet includes a multimeter. I want you to test it every week,
            and watch it keep working while others die.
          </p>
          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-599">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-600">
              Get Our Sheets at Production Cost - $109.90
            </h3>
            <CTAButton url="https://offer.bareearthlife.com/groundedsheets/checkout?uid=3062&oid=858&affid=719&sub1=fb2" data-id="element-601" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-602">
              Limited to current inventory of 278 sheets
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-603">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-604"></span>
            What My Wife Wants You to Know
          </h2>
          <div className="my-8" data-id="element-605">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wJRHd4MCiTYuuMZzCK8Lv3/17_Margaret_and_Tom.png" alt="Margaret and Tom Davidson sitting together in their home" className="w-full rounded-lg shadow-md" data-id="element-606" />
          </div>
          <p className="mb-5 text-base" data-id="element-607">Margaret made me add this:</p>
          <blockquote className="font-serif italic border-l-3 border-gray-400 pl-5 py-4 my-8 bg-yellow-50 rounded-r text-gray-700" data-id="element-608">
            "Tom spent our entire retirement fund on this. I wanted to kill him.
            But now, two years later, when people call amazed because they
            finally found sheets that work... I get it. We're not selling
            sheets. We're selling sleep. Real, consistent, lasting sleep."
          </blockquote>
          <p className="mb-5 text-base" data-id="element-609">
            Test them yourself. That's all I ask.
          </p>
          <p className="mb-6 text-base" data-id="element-610">
            Because once you see that multimeter still reading 30 ohms after a
            year while your old sheets are dead at 2,000 ohms, you'll understand
            why I spent my retirement fund on this.
          </p>
          <p className="mb-6 text-base" data-id="element-611">Some things are worth doing right.</p>
          <div className="border-t border-gray-200 mt-12 pt-6" data-id="element-612">
            <div className="flex items-center mb-4" data-id="element-613">
              <div className="w-8 h-8 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-614">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fGXq9Q6heUEMtiucmQrs1x/Tom-Davidson.jpg" alt="Tom Davidson" className="w-full h-full object-cover" data-id="element-615" />
              </div>
              <p className="text-sm text-gray-800" data-id="element-616">
                <span className="font-medium" data-id="element-617">Tom Davidson, 73,</span> retired
                from Corning after 32 years in fiber optic cable design. He
                lives in Louisville with his wife Margaret and personally
                oversees every grounding sheet produced.
              </p>
            </div>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-618">
              <strong data-id="element-619">P.S.</strong> – If you have a grounding sheet right now,
              test it with a multimeter. I'll bet $100 it's over 500 ohms
              (dead). That's not your fault. It's theirs.
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-620">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-621">
          <p className="mb-2" data-id="element-622">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
          <p className="mb-2" data-id="element-623">
            Individual results may vary. Results described in testimonials and
            case studies are not typical and your experience may differ.
          </p>
          <p className="mb-2" data-id="element-624">
            This article is for informational purposes only and is not intended
            as a substitute for advice from your physician or other healthcare
            professional.
          </p>
          <p className="mb-2" data-id="element-625">
            Any references to scientific studies, researchers, or institutions
            are for informational context only and do not imply endorsement of
            this product.
          </p>
          <p data-id="element-626">
            This is a paid advertisement for BareEarth and is not an actual news
            article or blog. The story and opinions expressed here are for
            promotional purposes only.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-627"></div>
    </div>;
};
export default AdvertorialAdv1;